import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, DateField, SelectField, Toolbar } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useRevenueRecognitionStore } from '../hooks/useRevenueRecognitionStore';
import { REVENUE_RECOGNITION_MODULES } from '../utils/constants';
import { ReveneuRecognitionModules } from '../types/types';
import { SearchableDateAutocomplete } from './searchableDateAutocomplete';

const useStyles = makeStyles(theme => ({
  entityLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  dropDownModuleBox: {
    display: 'flex',
    alignItems: 'center',
  },
  dropDownModule: {
    width: '400px',
    alignItems: 'center',
    display: 'flex'
  },
  item: {
    marginRight: '16px'
  },
  autoComplete: {
    width: '200px',
    marginRight: '16px'
  }
}));


export const RevenueRecognitionToolbar = observer(({ }) => {
  const classes = useStyles();
  const { revenueRecognitionStore } = useRevenueRecognitionStore();

  const getToolbarOptions = (moduleType: ReveneuRecognitionModules) => {
    return <SearchablesDatesToobarOption />
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Toolbar left={
          <Box className={classes.dropDownModuleBox}>
            <Box className={`${classes.dropDownModule} ${classes.item}`}>
              <Typography className={classes.item}>{'Module'}: </Typography>
              <SelectField
                multiple={false}
                testId={'typeOfFee'}
                fullWidth
                standaloneLabel
                variant="outlined"
                options={REVENUE_RECOGNITION_MODULES}
                onChange={value => {
                  revenueRecognitionStore.setSelectedModule(value);
                }}
                value={revenueRecognitionStore.selectedModule.value}
              />
            </Box>
            {getToolbarOptions(revenueRecognitionStore.selectedModule.value)}
          </Box>
        }>
          <Grid container spacing={2}>
            <Grid item>
              <Button
                id="basic-button"
                onClick={() => {
                  revenueRecognitionStore.exportDashboardData();
                }}
                testId="open_menu"
                variant="contained"
                size="small"
                color="primary"
                disabled={revenueRecognitionStore.exportingReport}
              >
                Export
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </Grid>
    </Grid>
  );
});

export const DatesToobarOption = () => {
  const classes = useStyles();
  const { revenueRecognitionStore } = useRevenueRecognitionStore();
  return (
    <>
      <DateField
        className={classes.item}
        testId="fromDate"
        views={["year", "month"]}
        format="MM/yyyy"
        label='From:'
        value={revenueRecognitionStore.parameter}
        onChange={(date) => { revenueRecognitionStore.setParam(date) }}
      />
    </>
  );
}

export const SearchablesDatesToobarOption = observer(({ }) => {
  const classes = useStyles();
  const { revenueRecognitionStore } = useRevenueRecognitionStore();
  const [fromValueDate, setFromValueDate] = useState('');
  const { months } = revenueRecognitionStore;

  useEffect(() => {
    revenueRecognitionStore.getMonths();
  }, [])

  useEffect(() => {
    validateFromDate();
  }, [months])

  const validateFromDate = () => {
    setFromValueDate(months.filter(month => month.value === revenueRecognitionStore.parameter)[0]?.label);
  }

  const onChangeDate = (updateInputValue, value: string) => {
    updateInputValue();
    revenueRecognitionStore.setParam(value);
  }

  return (
    <>
      <Typography className={classes.item}>{'From'}: </Typography>
      <SearchableDateAutocomplete
        placeHolder='Pick a date'
        options={months}
        value={fromValueDate}
        onChange={(newValue) => {
          setFromValueDate(newValue);
        }}
        onSelect={(option: any) => {
          onChangeDate(() => setFromValueDate(option.label), option.value);
        }}
        className={classes.autoComplete}
        onBlur={() => {
          if (fromValueDate === '') {
            validateFromDate();
          }
        }}
      />
    </>
  );
})